import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  title: {
    flexGrow: 1
  },
  imgSise: {
    height: 18,
    marginRight: theme.spacing(2)
  },
  imgNaseSeguros: {
    height: 30,
    marginLeft: theme.spacing(2)
  },
  divider: {
    width: 2,
    backgroundColor: 'gray'
  }
}));

export default useStyles;